import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { InformacoesSocioDemograficasDto } from "../../dtos/informacoes-socio-demograficas-dto";
import { CaqRequestService } from "../caq-request/caq-request.service";
import { LocalizacaoService } from "../localizacao/localizacao.service";
import { firstValueFrom, map } from "rxjs";

export interface InformacoesSocioDemograficasResponse<T> {
    content: InformacoesSocioDemograficasDto;
}

@Injectable({ providedIn: 'root' })
export class InformacoesSocioDemograficasService {
    public urlBase = `${environment.apiUrl}/informacoes-socio-demograficas`;

    constructor(
        private caqRequestService: CaqRequestService,
        private localizacaoService: LocalizacaoService
    ) { }

    async buscarPorLocalizacao(): Promise<InformacoesSocioDemograficasDto> {
        const url = this.construirUrl();

        return firstValueFrom(
            this.caqRequestService
                .get<InformacoesSocioDemograficasResponse<InformacoesSocioDemograficasDto>>(url)
                .pipe(map(res => res.content))
        );
    }

    private construirUrl(): string {
        const loc = this.localizacaoService.obterLocalizacaoSelecionada();

        if (loc?.cidadeSelecionada?.value) {
            return `${this.urlBase}/municipio/${loc.cidadeSelecionada.value}`;
        }
        if (loc?.estadoSelecionado?.value) {
            return `${this.urlBase}/estado/${loc.estadoSelecionado.value}`;
        }
        return `${this.urlBase}/nacional`;
    }

    buscarMunicipio(codMun: number | string) {
        return firstValueFrom(
            this.caqRequestService
                .get<InformacoesSocioDemograficasResponse<InformacoesSocioDemograficasDto>>(`${this.urlBase}/municipio/${codMun}`)
                .pipe(map(r => r.content))
        );
    }
    buscarEstado(codUf: number | string) {
        return firstValueFrom(
            this.caqRequestService
                .get<InformacoesSocioDemograficasResponse<InformacoesSocioDemograficasDto>>(`${this.urlBase}/estado/${codUf}`)
                .pipe(map(r => r.content))
        );
    }
    buscarNacional() {
        return firstValueFrom(
            this.caqRequestService
                .get<InformacoesSocioDemograficasResponse<InformacoesSocioDemograficasDto>>(`${this.urlBase}/nacional`)
                .pipe(map(r => r.content))
        );
    }
}
